import { createSlice } from '@reduxjs/toolkit';

export const drinksSlice = createSlice({
    name: 'drinks',
    initialState: {
        items: [],
        isLoading: true,
    },
    reducers: {
        setItems: (state, action) => {
            state.items = action.payload;
        },
        setIsLoading: (state, action) => {
            state.isLoading = action.payload;
        },
    }
});

export const { setItems, setIsLoading } = drinksSlice.actions;

export default drinksSlice.reducer;
